var version = {
    "name":      "dativery",
    "buildDateCode": "20260501-155842",
    "buildDate": "Fri May 01 2026 15:58:42 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260501-155842",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;